import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-privacybeleid',
  templateUrl: './privacybeleid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrivacybeleidComponent {}
